module.exports = __webpack_public_path__ + "static/icon-5-yellow-96b82b0b82b98af8daf7362433184448.png";